import * as React from "react"
import Carousel from 'react-bootstrap/Carousel'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { blue, jura, rubik, large, button, h100vhm60, bgdark, white } from '../shared.module.css'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import { useEffect, useContext } from "react"
import Context from '../context'

export function Head() {
	return (
		<>
			<title>Stanton - Industry Leading DJ Gear </title>
			<meta name="title" content="Stanton DJ " />
			<meta name="description" content="Stanton DJ are industry leaders in designing and manufacturing professional audio products for club and mobile DJs and turntablists. " />

			<meta property="og:type" content="website" />
			<meta property="og:url" content="https://stantondj.com/" />
			<meta property="og:title" content="Stanton DJ " />
			<meta property="og:description" content="Stanton DJ are industry leaders in designing and manufacturing professional audio products for club and mobile DJs and turntablists. " />
			<meta property="og:image" content="https://stantondj.com/stx.png" />

			<meta property="twitter:card" content="summary_large_image" />
			<meta property="twitter:url" content="https://stantondj.com/" />
			<meta property="twitter:title" content="Stanton DJ " />
			<meta property="twitter:description" content="Stanton DJ are industry leaders in designing and manufacturing professional audio products for club and mobile DJs and turntablists. " />
			<meta property="twitter:image" content='https://stantondj.com/stx.png' />
		</>
	)
}

export default function Index() {
    const { setLocation, setName, setPrice, setLink } = useContext(Context)
    
    useEffect(() => {
        setLocation(null)
        setName('')
        setPrice('')
        setLink('')
    }, [setLocation, setName, setPrice, setLink])

	return (
		<Container fluid className={`${bgdark}`}>
			<Container>
				<Row className={`${h100vhm60} ${bgdark} ${white} align-items-center`}>
					<Col>
						<Carousel interval={null}>
							<Carousel.Item>
								<Row className="mx-auto justify-content-center align-items-center">
									<Col xs={12} md={8}>
										<StaticImage src="../images/withdots_stanton_stx_angle_stand_withdots_8x10_72dpi-kracked-lossy.png" alt="" className={`img-fluid`} quality={100} loading='eager' placeholder='none' />
									</Col>
									<Col className="pb-5">
										<h1 className={jura}>
											STANTON<br />
											<span className={blue}>STX TURNTABLE</span>
										</h1>
										<p className={`${rubik} ${large}`}>The Stanton STX portable scratch turntable gives you <span className={blue}>instant access to your full turntablist skillset,</span> allowing you to share your skills with the world... whenever and wherever you’d like!</p>
										<Link to="/stx" className={`${button} ${rubik}`}>EXPLORE THE STX</Link>
									</Col>
								</Row>
							</Carousel.Item>
							<Carousel.Item>
								<Row className="mx-auto justify-content-center align-items-center">
									<Col className="px-md-4">
										<h2 className={`h1 ${jura}`}>
											STANTON<br />
											<span className={blue}>DS4 TURNTABLE CARTRIDGE</span>
										</h2>
										<p className={`${rubik} ${large}`}>Precision-engineered DJ cartridge for scratching, mixing, and DVS</p>
										<Link to="/ds4" className={`${button} ${rubik} d-inline-block`}>EXPLORE THE DS4</Link>
									</Col>
									<Col xs={12} md={8} className="my-5 text-end p-0">
										<StaticImage src="../images/1DS4-large.png" alt="" className="img-fluid" quality={100} placeholder='none' />
									</Col>
								</Row>
							</Carousel.Item>
						</Carousel>
					</Col>
				</Row>
			</Container>
		</Container>
	)
}